var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagBeCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#000",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 2
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2C2C2C",
  d: "M-.444-1C-1.856-1-3 .534-3 2.426v20.149c0 1.89 1.144 3.424 2.556 3.425H7V-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6D340",
  d: "M7 25.746h10V-.699H7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BC2933",
  d: "M25.126-1H17v27h8.126c.74 0 1.45-.36 1.973-1.002.524-.643.818-1.514.818-2.422V2.424C27.917.533 26.667-1 25.126-1"
}))));
export { SvgFlagBeCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjExIiBmaWxsPSJibGFjayIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiAvPgogICAgPG1hc2sgaWQ9Im1hc2swXzBfMTQzNCIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMSIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgLz4KICAgIDwvbWFzaz4KICAgIDxnIG1hc2s9InVybCgjbWFzazBfMF8xNDM0KSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICAgZD0iTS0wLjQ0NDMxOSAtMUMtMS44NTU5NSAtMC45OTkyNDEgLTMgMC41MzQyMDIgLTMgMi40MjU1NFYyMi41NzQ1Qy0zIDI0LjQ2NTggLTEuODU1OTUgMjUuOTk5MiAtMC40NDQzMTkgMjZIN1YtMUgtMC40NDQzMTkiCiAgICAgICAgICAgIGZpbGw9IiMyQzJDMkMiIC8+CiAgICAgICAgPHBhdGggZD0iTTcgMjUuNzQ2M0gxN1YtMC42OTg2MDhIN1YyNS43NDYzWiIgZmlsbD0iI0Y2RDM0MCIgLz4KICAgICAgICA8cGF0aAogICAgICAgICAgICBkPSJNMjUuMTI2IC0xSDE3VjI2SDI1LjEyNkMyNS44NjYxIDI2LjAwMDQgMjYuNTc2IDI1LjYzOTggMjcuMDk5NCAyNC45OTc2QzI3LjYyMjggMjQuMzU1NCAyNy45MTY5IDIzLjQ4NDIgMjcuOTE2OSAyMi41NzU4VjIuNDI0MTZDMjcuOTE2MiAwLjUzMjgyNyAyNi42NjY5IC0xIDI1LjEyNiAtMSIKICAgICAgICAgICAgZmlsbD0iI0JDMjkzMyIgLz4KICAgIDwvZz4KPC9zdmc+";